module.exports = __webpack_public_path__ + "media/images/v2/illustration_5-3e03d5ec797be0b94e07d8c294bf08d6.svg";